import axios from "axios";
import { create } from "zustand";

export let useAudios = create((set, get) => ({
    videos: [],
    ed: {},
    setEd: (data) => {
        set({ ed: data })
    },
    columns: [
        {
            title: 'ID',
            dataIndex: "id",
            key: "id",
            width: 150,
        },
        {
            title: 'Nomi',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Audio',
            key: 'player',
            render: (_, rec)=>(
                <audio src={rec.url} controls></audio>
            )
        },
        {
            title: 'Kategoriya',
            dataIndex: 'category',
            key: 'category',
        },
       
    ],
    setVideo: async () => {
        axios.get('audio')
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ videos: data });
            })
            .catch((err) => {
                console.error('Audiolarni yuklab olishda xatolik:', err);
                set({ videos: [] });
            })
    },
    delVideo: (id) => {
        axios.delete(`audio/${id.id}`)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Audio o\'chirishda xatolik:', err);
            })
    },
    addVideo: (data) => {
        axios.post('audio', data)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Audio qo\'shishda xatolik:', err);
            })
    },
    editVideo: (data) => {
        axios.put(`audio/${data.id}`, data)
            .then((res) => {
                get().setVideo();
            })
            .catch((err) => {
                console.error('Audio taxrirlashda xatolik:', err);
            })
    }
}))